import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState } from 'react';
const SearchedCredentialsStateDefault = {
    searched: null,
    setSearched: null
};
export const SFTPConfigContext = createContext(SearchedCredentialsStateDefault);
function SFTPConfigProvider({ children }) {
    const [searched, setSearched] = useState(false);
    const value = useMemo(() => ({ searched, setSearched }), [searched]);
    return _jsx(SFTPConfigContext.Provider, { value: value, children: children });
}
export default SFTPConfigProvider;
